
import {
  Vue, Component, Prop, Watch, Ref,
} from 'vue-property-decorator'
import FormInput from '@/components/FormInput/FormInput.vue'
import Widget from '@/components/Widget/Widget.vue'
import { clone as _clone } from 'lodash'
// @ts-ignore
import LiquorTree from 'liquor-tree'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import ColorManager from '@/models/interface/ColorManager'
import CheckboxInput from '@/components/CheckboxInput/index.vue'
import DataForm from '@/components/DataForm/DataForm.vue'
import MediaPackage from '@/models/MediaPackage'
import SpecialPackageWidget from '@/components/SpecialPackage/SpecialPackageWidget.vue'
import WebMessage from '@/models/WebMessage'
import BetaOnlyNotice from '@/components/BetaOnlyNotice/BetaOnlyNotice.vue'
import { betaMediaPackageUrl } from '@/helpers/beta'
import formData from './form'
import DistributionGoalGroup from './components/DistributionGoalGroup.vue'

Vue.use(LiquorTree)

@Component({
  components: {
    DataForm,
    FormInput,
    CheckboxInput,
    Widget,
    VueSlider,
    DistributionGoalGroup,
    BetaOnlyNotice,
    SpecialPackageWidget,
  },
})
export default class MediaPackageForm extends Vue {
  @Ref() readonly treeview: any

  @Prop({ default: '' })
  private id!: string

  @Prop({
    default: 'full',
  })
  private view_mode!: string

  public adunit_filter: string = ''

  public adunits = []

  public adunits_distribution: number[] = []

  public busy = false

  public loading = true

  public model: MediaPackage = new MediaPackage()

  public show_line_items_using_this: boolean = false

  public depending_line_items: any = []

  public confirm_update: any = false

  public response_msg: any = ''

  public can_save: boolean = true

  public smart_package_blocked: boolean = false

  public slider = {
    marks: (val: number) =>
      (val % 10 === 0
        ? {
          label: `${val}%`,
        }
        : false),
    process: (dotpos: number[]) => {
      let ret = []
      for (let i = 0; i < dotpos.length; i++) {
        ret.push([
          i === 0 ? 0 : dotpos[i - 1],
          dotpos[i],
          { backgroundColor: ColorManager.getColorByIndex(i) },
        ])
      }
      return ret
    },
  }

  public get form() {
    return formData
  }

  public cancel() {
    if (this.view_mode == 'sidebar') {
      this.$emit('update:show_sidebar', false)
    } else {
      this.$router.push({ name: 'Users' })
    }
  }

  public getSliderDataByIndex(index: number) {
    const checked = this.treeview.checked()
    let value = (this.adunits_distribution[index]
        - (index === 0 ? 0 : this.adunits_distribution[index - 1]))
      / 100
    return {
      name: checked[index].data.text,
      value,
    }
  }

  public updateAdUnits() {
    this.model.adunit_ids = this.treeview.checked().map((x: any) => x.id)

    if (this.model.adunit_ids.length > 0) {
      let base = 100 / this.model.adunit_ids.length
      let distribution = []
      for (let i = 0; i < this.model.adunit_ids.length; i++) {
        distribution.push(base * (i + 1))
      }
      this.adunits_distribution = distribution
    }
  }

  public saveWithoutUpdate() {
    this.show_line_items_using_this = false
    this.confirm_update = false
    this.onSubmit(this.model, false)
  }

  public onSubmit(model: MediaPackage, confirm = true) {
    if (!this.can_save) {
      WebMessage.error('The distribution goals are not valid, some types are duplicated.')
      return
    }
    this.busy = true

    const save = () => {
      model.confirmed_update = this.confirm_update
      model.save().then(response => {
        this.busy = false

        if (response.status == 200) {
          this.$router.push({ name: 'MediaPackages' })
        }
      })
    }

    if (!this.confirm_update && confirm && model.id) {
      MediaPackage.checkPackageUsage(model.id).then(data => {
        if (data.result.media_package.length) {
          this.show_line_items_using_this = true
          this.depending_line_items = data.result.media_package
          this.response_msg = data.message
          this.busy = false
        } else {
          save()
        }
      })
    } else {
      save()
    }
  }

  public init() {
    this.loading = true
    const { query } = this.$route
    if (this.id) {
      MediaPackage.find(this.id).then(media_package => {
        if (media_package instanceof MediaPackage) {
          if (this.blockIfSmart(media_package)) return

          this.model = media_package
          if (!this.model.custom_targeting) {
            this.model.custom_targeting = []
          }
          if (!media_package.special_packages) {
            this.model.special_packages = []
          }
          this.loading = false
        }
      })
    } else if (query.from && typeof query.from === 'string') {
      MediaPackage.find(query.from).then(media_package => {
        if (media_package instanceof MediaPackage) {
          if (this.blockIfSmart(media_package)) return

          this.model = media_package.clone()
          if (!this.model.custom_targeting) {
            this.model.custom_targeting = []
          }
          if (!media_package.special_packages) {
            this.model.special_packages = []
          }
          this.model.id = ''
          this.loading = false
        }
      })
    } else {
      this.loading = false
    }
  }

  public get beta_url(): string {
    return betaMediaPackageUrl(this.id || (this.$route.query.from as string) || '')
  }

  public blockIfSmart(media_package: MediaPackage): boolean {
    if (!media_package.smart_distribution) return false

    this.smart_package_blocked = true
    this.loading = false

    return true
  }

  public goBack() {
    this.$router.push({ name: 'MediaPackages' })
  }

  public created() {
    this.init()
  }
}
